import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-m-frame-size",
  "use": "icon-m-frame-size-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-m-frame-size\"><path d=\"M39 0a1 1 0 0 1 0 2h-4.5v36H39a1 1 0 0 1 0 2H28a1 1 0 0 1 0-2h4.5V2H28a1 1 0 0 1 0-2zM10 0a7 7 0 0 1 4.212 12.591A9 9 0 0 1 20 21v7a3 3 0 0 1-3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-6a3 3 0 0 1-3-3v-7a9 9 0 0 1 5.788-8.41A7 7 0 0 1 10 0m1 14H9a7 7 0 0 0-7 7v7a1 1 0 0 0 1 1h2v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8h2a1 1 0 0 0 1-1v-7a7 7 0 0 0-7-7M10 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol